import { render, staticRenderFns } from "./Text1.vue?vue&type=template&id=8915dabc&scoped=true&"
import script from "./Text1.vue?vue&type=script&lang=js&"
export * from "./Text1.vue?vue&type=script&lang=js&"
import style0 from "./Text1.vue?vue&type=style&index=0&id=8915dabc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8915dabc",
  null
  
)

export default component.exports